<template>
  <div id="movie">
    <nav-bar>
      <span slot="leftSpan">Movies</span>
      <input
        slot="center"
        class="search"
        type="text"
        placeholder="生活就像一盒巧克力,你永远不知道你会得到什么"
        v-model="inputValue"
        @keyup.enter="addItem"
      />
      <span slot="rightSpan">🎬</span>
    </nav-bar>
    <task-bar>
      <is-read
        slot="tagging"
        :todo="todo"
        @reClick="change"
        :todoWord="[
          '未看' + '(' + todoCount + ')',
          '已看' + '(' + doneCount + ')',
        ]"
      ></is-read>
      <span v-if="!todoCount && todo">快来添加你想看的电影吧</span>
      <span v-if="!doneCount && !todo">你还没有看完的电影哦</span>
      <transition-group name="ani">
        <list-item
          v-for="(item, index) in myMovie"
          v-show="todo && !item.done"
          :item="item.title"
          :done="item.done"
          :key="item.tid"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>
      <transition-group name="ani">
        <list-item
          v-for="(item, index) in myMovie"
          v-show="!todo && item.done"
          :item="item.title"
          :done="item.done"
          :key="item.tid"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>
    </task-bar>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar.vue";
import TaskBar from "components/content/taskbar/TaskBar.vue";
import ListItem from "components/content/listItem/ListItem.vue";
import IsRead from "components/common/isRead/IsRead.vue";

import { getData, saveData, deleteData } from "assets/js/todoList.js";

export default {
  name: "Movie",
  components: {
    NavBar,
    TaskBar,
    ListItem,
    IsRead,
  },
  data() {
    return {
      todo: true,
      myMovie: [
        // {title: '🍎吃苹果', done: true},
        // {title: '🍓吃草莓', done: false},
        // {title: '🍌吃香蕉', done: true},
        // {title: '🍈吃橘子', done: false},
        // {title: '🍉吃西瓜', done: false},
      ],
      inputValue: "",
    };
  },
  computed: {
    //未完成数量
    todoCount() {
      return this.myMovie.filter((item) => {
        return !item.done;
      }).length;
    },

    //已完成数量
    doneCount() {
      return this.myMovie.filter((item) => {
        return item.done;
      }).length;
    },
  },
  // 页面加载即渲染所有数据
  created() {
    let allList = getData("myMovie");
    this.myMovie = allList;
  },
  watch: {
    myMovie: {
      handler() {
        saveData(this.myMovie, "myMovie");
      },
      deep: true, //深监听
    },
  },
  methods: {
    addItem(e) {
      let data = e.target.value;
      if (data === "") {
        return alert("请输入电影名称");
      }
      this.myMovie.push({
        title: data,
        done: false,
        tid: new Date().valueOf(),
      });
      this.inputValue = "";
    },
    change() {
      this.todo = !this.todo;
    },
    deleteItem(index) {
      this.myMovie.splice(index, 1);
    },
    isDone(index) {
      this.myMovie[index].done = !this.myMovie[index].done;
    },
  },
};
</script>

<style scoped lang="less">
</style>